export const utils = function () {

  var positiveColor = '#35D980';
  var negativeColor = '#FF4959';

  var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };

  return {
    positiveColor: positiveColor,
    negativeColor: negativeColor,
    hexToRgb: hexToRgb
  }

}();


export const hexToRGBa = (hex, alpha) => {
  let r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

export const API_URL = "https://api.audiar.bakasable.fr/";

// export const API_URL = "https://api.audiar.bakasable.io/";

// export const LOCAL_API_URL = "http://localhost:30005/";

export const validateEmail = (email) => {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const handleChangeQuery = (key, value) => {
  const url = new URL(window.location);
  url.searchParams.set(key, value);
  window.history.pushState({}, '', url);
}

export const parseQuery = (queryString) => {
  // var query = {};
  // var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  // for (var i = 0; i < pairs.length; i++) {
  //     var pair = pairs[i].split('=');
  //     query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  // }
  //return query;
  const params = Object.fromEntries(new URLSearchParams(queryString));
  // var search = queryString.substring(1);
  // return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"').replace(/=/g,'+') + '"}');
  return params;
}